// extracted by mini-css-extract-plugin
module.exports = {"container":"CardOfferRadio_container__jxCKt","input":"CardOfferRadio_input__VeyMD","default":"CardOfferRadio_default__3jQCz","checked":"CardOfferRadio_checked__2LFqq"};